<style>
@import './assets/styles/style.css';
</style>

<template>
  <div id="app">
    <Wesenstest></Wesenstest>
  </div>
</template>

<script>
import Wesenstest from './components/Kommunikationstypen-Test.vue'

export default {
  name: 'app',
  components: {
    Wesenstest
  }
}
</script>
